import useSWR, { SWRResponse } from 'swr';
import ICategory from '../interfaces/ICategory';
import { CategoryTag } from '../models/category';
import apiService from './ApiService';

const useCategoryTree = (): { tree: ICategory; isLoading: boolean; error: any } => {
  const { data, error } = useSWR(
    '/category-tree',
    () => apiService.get(`api/categories/tree`).then((res) => res.data),
    { shouldRetryOnError: false }
  );

  return {
    tree: data,
    isLoading: !data && !error,
    error,
  };
};

function useCategoryTag(sku: string): SWRResponse<CategoryTag[], Error> {
  return useSWR(
    `/categoryTag/${sku}`,
    async () => (await apiService.get(`api/categories/categoryTag/${sku}`)).data,
    {
      shouldRetryOnError: false,
    }
  );
}

export default useCategoryTree;
export { useCategoryTag };
